import type { BatteryProposalLoanProgramDto } from "~/api/dto/battery-proposal.dto"

export const resolveBatteryLoanProgramId = ({
  draftLoanProgramId,
  loanPrograms,
}: {
  draftLoanProgramId: number | null
  loanPrograms: BatteryProposalLoanProgramDto[]
}): number | null => {
  const required = loanPrograms.find((program) => program.isRequired)
  const current =
    draftLoanProgramId == null
      ? undefined
      : loanPrograms.find(
          (program) => program.powurOsLoanProgramId === draftLoanProgramId,
        )

  if (current != null && (required == null || current.isRequired)) {
    return current.powurOsLoanProgramId
  }

  return (
    (required ?? loanPrograms.find((program) => program.isDefault) ?? null)
      ?.powurOsLoanProgramId ?? null
  )
}
